import { render } from "./AdminMaterialsView.vue?vue&type=template&id=33879fc4"
import script from "./AdminMaterialsView.vue?vue&type=script&lang=js"
export * from "./AdminMaterialsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__